/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiIntegrationsDtoConnectIntegrationDto,
  WebApiIntegrationsDtoCreateAgreementDto,
  WebApiIntegrationsDtoCreateMultiplePaymentLinkDto,
  WebApiIntegrationsDtoCreatePaymentLinkDto,
  WebApiIntegrationsDtoIntegrationDto,
  WebApiIntegrationsDtoPaymentLinkCallbackDto,
  WebApiIntegrationsObjectsIntegrationType,
  WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse,
} from '../models';
import {
    WebApiIntegrationsDtoConnectIntegrationDtoFromJSON,
    WebApiIntegrationsDtoConnectIntegrationDtoToJSON,
    WebApiIntegrationsDtoCreateAgreementDtoFromJSON,
    WebApiIntegrationsDtoCreateAgreementDtoToJSON,
    WebApiIntegrationsDtoCreateMultiplePaymentLinkDtoFromJSON,
    WebApiIntegrationsDtoCreateMultiplePaymentLinkDtoToJSON,
    WebApiIntegrationsDtoCreatePaymentLinkDtoFromJSON,
    WebApiIntegrationsDtoCreatePaymentLinkDtoToJSON,
    WebApiIntegrationsDtoIntegrationDtoFromJSON,
    WebApiIntegrationsDtoIntegrationDtoToJSON,
    WebApiIntegrationsDtoPaymentLinkCallbackDtoFromJSON,
    WebApiIntegrationsDtoPaymentLinkCallbackDtoToJSON,
    WebApiIntegrationsObjectsIntegrationTypeFromJSON,
    WebApiIntegrationsObjectsIntegrationTypeToJSON,
    WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseFromJSON,
    WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseToJSON,
} from '../models';

export interface ApiIntegrationCancelPaymentLinkDeleteRequest {
    paymentUrl?: string;
}

export interface ApiIntegrationCreateAndPublishPingPaymentAgreementPostRequest {
    webApiIntegrationsDtoCreateAgreementDto?: WebApiIntegrationsDtoCreateAgreementDto;
}

export interface ApiIntegrationCreateMultiplePaymentLinksPostRequest {
    webApiIntegrationsDtoCreateMultiplePaymentLinkDto?: WebApiIntegrationsDtoCreateMultiplePaymentLinkDto;
}

export interface ApiIntegrationCreatePaymentLinkPostRequest {
    webApiIntegrationsDtoCreatePaymentLinkDto?: WebApiIntegrationsDtoCreatePaymentLinkDto;
}

export interface ApiIntegrationDeleteRequest {
    integrationId?: number;
}

export interface ApiIntegrationGetRequest {
    type?: WebApiIntegrationsObjectsIntegrationType;
}

export interface ApiIntegrationGetInvoicesGetRequest {
    type?: WebApiIntegrationsObjectsIntegrationType;
}

export interface ApiIntegrationHandlePaymentLinkCallbackPostRequest {
    webApiIntegrationsDtoPaymentLinkCallbackDto?: WebApiIntegrationsDtoPaymentLinkCallbackDto;
}

export interface ApiIntegrationPostRequest {
    webApiIntegrationsDtoConnectIntegrationDto?: WebApiIntegrationsDtoConnectIntegrationDto;
}

export interface ApiIntegrationSettlePaymentOrderPostRequest {
    body?: string;
}

export interface ApiIntegrationSyncFortNoxDataPostRequest {
    body?: number;
}

/**
 * 
 */
export class IntegrationApi extends runtime.BaseAPI {

    /**
     * 
     */
    async apiIntegrationCancelPaymentLinkDeleteRaw(requestParameters: ApiIntegrationCancelPaymentLinkDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.paymentUrl !== undefined) {
            queryParameters['paymentUrl'] = requestParameters.paymentUrl;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CancelPaymentLink`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async apiIntegrationCancelPaymentLinkDelete(requestParameters: ApiIntegrationCancelPaymentLinkDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiIntegrationCancelPaymentLinkDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiIntegrationCreateAndPublishPingPaymentAgreementPostRaw(requestParameters: ApiIntegrationCreateAndPublishPingPaymentAgreementPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CreateAndPublishPingPaymentAgreement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoCreateAgreementDtoToJSON(requestParameters.webApiIntegrationsDtoCreateAgreementDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async apiIntegrationCreateAndPublishPingPaymentAgreementPost(requestParameters: ApiIntegrationCreateAndPublishPingPaymentAgreementPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiIntegrationCreateAndPublishPingPaymentAgreementPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get integration by type
     */
    async apiIntegrationCreateMultiplePaymentLinksPostRaw(requestParameters: ApiIntegrationCreateMultiplePaymentLinksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CreateMultiplePaymentLinks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoCreateMultiplePaymentLinkDtoToJSON(requestParameters.webApiIntegrationsDtoCreateMultiplePaymentLinkDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseFromJSON(jsonValue));
    }

    /**
     * Get integration by type
     */
    async apiIntegrationCreateMultiplePaymentLinksPost(requestParameters: ApiIntegrationCreateMultiplePaymentLinksPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse> {
        const response = await this.apiIntegrationCreateMultiplePaymentLinksPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get integration by type
     */
    async apiIntegrationCreatePaymentLinkPostRaw(requestParameters: ApiIntegrationCreatePaymentLinkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CreatePaymentLink`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoCreatePaymentLinkDtoToJSON(requestParameters.webApiIntegrationsDtoCreatePaymentLinkDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseFromJSON(jsonValue));
    }

    /**
     * Get integration by type
     */
    async apiIntegrationCreatePaymentLinkPost(requestParameters: ApiIntegrationCreatePaymentLinkPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse> {
        const response = await this.apiIntegrationCreatePaymentLinkPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get integration by type
     */
    async apiIntegrationDeleteRaw(requestParameters: ApiIntegrationDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.integrationId !== undefined) {
            queryParameters['integrationId'] = requestParameters.integrationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get integration by type
     */
    async apiIntegrationDelete(requestParameters: ApiIntegrationDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiIntegrationDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get integration by type
     */
    async apiIntegrationGetRaw(requestParameters: ApiIntegrationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoIntegrationDto>> {
        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoIntegrationDtoFromJSON(jsonValue));
    }

    /**
     * Get integration by type
     */
    async apiIntegrationGet(requestParameters: ApiIntegrationGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoIntegrationDto> {
        const response = await this.apiIntegrationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiIntegrationGetActiveIntegrationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiIntegrationsDtoIntegrationDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetActiveIntegrations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiIntegrationsDtoIntegrationDtoFromJSON));
    }

    /**
     * 
     */
    async apiIntegrationGetActiveIntegrationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiIntegrationsDtoIntegrationDto>> {
        const response = await this.apiIntegrationGetActiveIntegrationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiIntegrationGetInvoicesGetRaw(requestParameters: ApiIntegrationGetInvoicesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetInvoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async apiIntegrationGetInvoicesGet(requestParameters: ApiIntegrationGetInvoicesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.apiIntegrationGetInvoicesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get integration by type
     */
    async apiIntegrationHandlePaymentLinkCallbackPostRaw(requestParameters: ApiIntegrationHandlePaymentLinkCallbackPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/HandlePaymentLinkCallback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoPaymentLinkCallbackDtoToJSON(requestParameters.webApiIntegrationsDtoPaymentLinkCallbackDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseFromJSON(jsonValue));
    }

    /**
     * Get integration by type
     */
    async apiIntegrationHandlePaymentLinkCallbackPost(requestParameters: ApiIntegrationHandlePaymentLinkCallbackPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse> {
        const response = await this.apiIntegrationHandlePaymentLinkCallbackPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiIntegrationPostRaw(requestParameters: ApiIntegrationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoIntegrationDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoConnectIntegrationDtoToJSON(requestParameters.webApiIntegrationsDtoConnectIntegrationDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoIntegrationDtoFromJSON(jsonValue));
    }

    /**
     * 
     */
    async apiIntegrationPost(requestParameters: ApiIntegrationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoIntegrationDto> {
        const response = await this.apiIntegrationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiIntegrationSettlePaymentOrderPostRaw(requestParameters: ApiIntegrationSettlePaymentOrderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/SettlePaymentOrder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiIntegrationSettlePaymentOrderPost(requestParameters: ApiIntegrationSettlePaymentOrderPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationSettlePaymentOrderPostRaw(requestParameters, initOverrides);
    }

    /**
     * Gets and Save invoices
     */
    async apiIntegrationSyncFortNoxDataPostRaw(requestParameters: ApiIntegrationSyncFortNoxDataPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/SyncFortNoxData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Gets and Save invoices
     */
    async apiIntegrationSyncFortNoxDataPost(requestParameters: ApiIntegrationSyncFortNoxDataPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.apiIntegrationSyncFortNoxDataPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
